export var BoardingContent;
(function (BoardingContent) {
    BoardingContent["BoatAlongside"] = "boat alongside";
    BoardingContent["OnTheLadder"] = "on the ladder";
    BoardingContent["OnDeck"] = "on deck";
    BoardingContent["OnBridge"] = "on bridge";
})(BoardingContent || (BoardingContent = {}));
//# sourceMappingURL=BoardingContent.js.map